<template>
  <div class="instrumentTime">
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="时间">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="院区">
          <el-select clearable v-model="filters.areaName" placeholder="选择院区">
            <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="buttonText">
        <!-- <div class="delete" @click="delAll">批量删除</div>
        <div class="addData" @click="add">新增</div> -->
        <el-button type="warning" @click="add" icon="el-icon-edit">新增</el-button>
        <el-button type="danger" @click="delAll" icon="el-icon-delete">批量删除</el-button>
      </div>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
        <el-table-column sortable prop="areaName" label="院区"></el-table-column>
        <el-table-column sortable prop="floorName" label="楼层"></el-table-column>
        <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
        <el-table-column sortable prop="createTime" label="添加时间" width="100"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="forbidden" label="禁用" width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.Forbidden" active-color="#13ce66" inactive-color="#C9C9C9" :inactive-value="0" :active-value="1" @change="change(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增编辑身份弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formData" label-width="100px">
        <el-form-item label="院区">
          <el-select clearable v-model="formData.areaName" placeholder="选择院区" style="width:90%;">
            <el-option v-for="(item) in areaOptions" :key="item.areaCode" :label="item.areaName" :value="item.areaName">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="flex" v-for="(domain, index) in formData.floorNameList" :key="index">
          <el-form-item label="科室/楼层" style="width:90%;">
            <el-select v-model="domain.departmentCode" placeholder="请选择科室" style="width:43%;margin-right:5.1%;">
              <el-option v-for="(item) in offices" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <el-input v-model.trim="domain.floorName" placeholder="请输入楼层" style="width:43%;margin-right:5.1%;"></el-input>
          </el-form-item>
          <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(domain,index)" v-show="index > 0">
            <i class="el-icon-delete"></i>
          </el-button>
        </div>
        <el-form-item>
          <el-button @click="editAddDomain" type="primary" size="mini">添加科室楼层</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
        <el-button type="primary" @click="doAddgoods()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, } from 'vuex'
export default {
  name: 'yard',
  computed: {
    ...mapState(['areaOptions', 'floorOptions']),
  },
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      formData: {
        floorNameList: [
          {
            floorName: '',
            departmentCode: '',
          }
        ]
      },
      tableHeight: "",
      isId: '',
      offices: [
        {
          name: '美容皮肤科',
          id: '001'
        },
        {
          name: '美容外科',
          id: '002'
        },
        {
          name: '注射微整科',
          id: '003'
        },
      ],
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 380
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      if (this.activatedFlag) {
        this.query(this.filters.pagination.page);
      }
    },
  },
  methods: {
    testSX() {
      this.$forceUpdate()
    },
    // 编辑时新增部位
    editAddDomain(index) {
      this.formData.floorNameList.push({
        key: Date.now(),
        floorName: '',
        departmentCode: '',
      });
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    // 编辑时删除部位
    editRemoveDomain(item, listIndex) {
      var index = this.formData.floorNameList.indexOf(item)
      if (index !== -1) {
        this.formData.floorNameList.splice(listIndex, 1)
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // 新增项目
    add() {
      this.dialogFormVisible = true
      this.isId = ''
      // 新增置空
      this.formData = {
        floorNameList: [
          {
            floorName: '',
            departmentCode: ''
          }
        ]
      }
    },

    handleEdit(index, row) {
      console.log(row);
      this.isId = row.id
      this.dialogFormVisible = true
      let querys = {
        id: row.id,
      }
      api.request('/skn/findSknAreaAndFloorMenuById', querys, (res) => {
        this.formData = res.data
      })
    },
    doAddgoods() {
      this.formData.createBy = Lockr.get('skinEmpId')
      this.formData.floorNameList.forEach(item => {
        this.offices.forEach(ele => {
          if (item.departmentCode == ele.id) {
            item.departmentName = ele.name
          }
        });
      });
      console.log(this.formData);
      if (this.isId) {
        api.requestQuiet("/skn/updateSknAreaAndFloorMenu", this.formData, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", '修改成功');
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", res.errMsg);
          }
        }, (err) => { });
      } else if (!this.isId) {
        api.requestQuiet("/skn/createSknAreaAndFloorMenu", this.formData, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", '添加成功');
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", res.errMsg);
          }
        }, (err) => { });
      }

    },
    // 删除项目
    del(index, row) {
      let querys = {
        id: row.id,
      }
      this.$confirm('确定要该条数据吗？', '删除项目', {
        center: true
      })
        .then((res) => {
          api.request("/skn/deleteSknAreaAndFloorMenuById", querys, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "删除失败")
              this.query(this.filters.pagination.page)
            }
          })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })
    },
    // 批量删除
    delAll() {
      var data = this.multipleSelection;
      var id = [];
      data.map(function (item, index) {
        console.log(item)
        id.push(item.id);
      });
      this.$confirm("确定要删除选中的数据吗？", "删除项目", {
        center: true,
      })
        .then((res) => {
          api.requestQuiet(
            "/skn/deleteSknAreaAndFloorMenuAll", {
              idList: id.toString(),
            },
            (res) => {
              if (res.result == true) {
                _g.toast("success", "删除成功");
                this.query(this.filters.pagination.page);
              } else {
                _g.toast("error", "删除失败");
                this.query(this.filters.pagination.page);
              }
            }
          );
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });
    },
    change(index, row) {
      console.log(row);
      let data = {
        id: row.id
        // 0：正常 1：禁用
      }
      api.request("/skn/updateSknAreaAndFloorMenuForbidden", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "状态修改成功")
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "状态修改失败")
          this.query(this.filters.pagination.page)
        }
      })
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.startTime)
      var querys = {
        // project: this.filters.project,
        // projectCategory: this.filters.projectCategory,
        startTime: '',
        endTime: '',
        page: page,
        size: this.filters.pagination.limit,
        areaName: this.filters.areaName,
        floorName: ""
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.request('/skn/findSknAreaAndFloorMenuPage', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.filters.pagination.total = parseInt(res.data.count)
      })
    },
  },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
.flex {
  display: flex;
  align-items: flex-start;
}
.flex >>> .el-button i {
  margin: 0 !important;
}
.flex >>> .el-button--mini {
  margin: 8px;
}
</style>